import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./common/styles/normalizer.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "styled-components";
const theme = {
  footer: {
    width: "100vw",
    height: "85px",
    position: "fixed",
    top: "100%",
    transform: "translateY(-100%)",
    backdropFilter: "blur(7px)",
    overflow: "hidden",
  },
  navigationBarHeight: "40px",
};
ReactDOM.render(
  <ThemeProvider theme={theme}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </ThemeProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
